import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Typography,
  Grid,
  InputLabel,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../components/App.css";
import axios from "axios";
import { ADMIN_BASE_URL } from "../config/config";
import BevHeader from "../components/BevHeader";
import BevFooter from "../components/BevFooter";
import PasswordField from "../components/PasswordField";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");

  const handleLogin = async (values, { setSubmitting }) => {
    setLoginError("");

    try {
      const response = await axios.post(`${ADMIN_BASE_URL}/login`, {
        username: values.username,
        password: values.password,
        rememberMe: true,
      });

      const { data } = response;

      if (data.status && data.token) {
        localStorage.setItem("care_admin_token", data.token);
        navigate("/admin");
        return;
      }

      setLoginError(data.msg || "Login failed. Please check your credentials.");
    } catch (error) {
      console.error("Error occurred:", error);
      setLoginError(
        error.response?.data?.msg ||
          "Unable to reach the server. Please try again later."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <BevHeader />
      <div className="login-container">
      <div className="login-form">
        <img
          src="https://bevogtet.com/partner/static/media/logo.ed119271e4a3d3ac775e.jpg"
          alt="Logo"
          width={120}
          className="form-logo"
        />
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          textAlign="center"
          marginBottom="20px"
          paddingBottom="10px"
          borderBottom="1px solid #ccc"
        >
          Welcome to Bevogtet Admin, Login below!
        </Typography>
        <Formik
          initialValues={{
            username: "",
            password: "",
          }}
          validationSchema={Yup.object({
            username: Yup.string().required("Username is required"),
            password: Yup.string().required("Password is required"),
          })}
          onSubmit={handleLogin}
        >
          {({ isSubmitting }) => (
            <Form>
              <Grid container spacing={2}>
                {loginError && (
                  <Grid item xs={12}>
                    <Alert severity="error">{loginError}</Alert>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <InputLabel htmlFor="username">Username</InputLabel>
                  <Field
                    as={TextField}
                    name="username"
                    size="small"
                    variant="outlined"
                    fullWidth
                    disabled={isSubmitting}
                  />
                  <ErrorMessage
                    name="username"
                    component="div"
                    className="login-error"
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="password">Password</InputLabel>
                  <Field
                    name="password"
                    component={PasswordField}
                    size="small"
                    variant="outlined"
                    fullWidth
                    disabled={isSubmitting}
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="login-error"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    fullWidth
                    disabled={isSubmitting}
                    startIcon={
                      isSubmitting ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : null
                    }
                  >
                    {isSubmitting ? "Logging in..." : "Login"}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    </div>
      <BevFooter />
    </>
  );
};

export default AdminLogin;
